import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { NativeSelect, Panel } from "@/components/common";
import { Switch } from "@/components/ui/switch";

export default function EmailPrefs() {
  const { t, locale } = useLang();
  const [p, setP] = useState(null);
  const [dl, setDl] = useState([]);
  const loadDl = () => api.get("/fta/deadlines").then((r) => setDl(r.data));
  useEffect(() => { api.get("/preferences").then((r) => setP(r.data)); loadDl(); }, []);
  if (!p) return null;
  const set = async (k, v) => {
    const next = { ...p, [k]: v };
    setP(next);
    try { await api.put("/preferences", next); toast.success(t("saved")); if (k === "vat_period") loadDl(); } catch (e) { toast.error(errMsg(e)); }
  };
  const Row = ({ k, label, text }) => (
    <div className="flex items-center justify-between gap-4 py-3">
      <div><p className="text-sm font-semibold text-slate-800">{label}</p><p className="text-xs text-slate-500">{text}</p></div>
      <Switch data-testid={`pref-${k}`} checked={p[k]} onCheckedChange={(v) => set(k, v)} />
    </div>
  );
  return (
    <Panel className="mt-6 max-w-3xl p-6" data-testid="email-prefs-panel">
      <h3 className="font-display text-lg font-bold">{t("emailPrefs")}</h3>
      <div className="mt-2 divide-y divide-slate-100">
        <Row k="auto_send_invoices" label={t("prefAutoSend")} text={t("prefAutoSendText")} />
        <Row k="reminders_enabled" label={t("prefReminders")} text={t("prefRemindersText")} />
        <Row k="monthly_report_enabled" label={t("prefMonthly")} text={t("prefMonthlyText")} />
        <Row k="notify_email_enabled" label={t("prefNotify")} text={t("prefNotifyText")} />
        <Row k="fta_deadline_alerts" label={t("prefFta")} text={t("prefFtaText")} />
        <div className="flex items-center justify-between gap-4 py-3">
          <div><p className="text-sm font-semibold text-slate-800">{t("vatPeriod")}</p><p className="text-xs text-slate-500">{t("vatPeriodText")}</p></div>
          <NativeSelect data-testid="pref-vat_period" className="w-44" value={p.vat_period} onChange={(e) => set("vat_period", e.target.value)}>
            <option value="quarterly">{t("quarterly")}</option><option value="monthly">{t("monthly")}</option>
          </NativeSelect>
        </div>
      </div>
      {dl.length > 0 && (
        <div className="mt-4 rounded-lg bg-slate-50 p-4" data-testid="fta-deadlines">
          <div className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500"><CalendarClock className="h-4 w-4 text-[#D4AF37]" />{t("upcomingDeadlines")}</div>
          <ul className="space-y-1 text-sm">
            {dl.map((d) => (
              <li key={`${d.kind}-${d.deadline}`} data-testid={`fta-deadline-${d.kind}-${d.deadline}`} className="flex items-center justify-between">
                <span className="text-slate-700">{t(d.kind === "vat" ? "vatDeadline" : "ctDeadline")} <span className="text-slate-400">({t("periodEnding")} {d.period_end})</span></span>
                <span className={`font-mono text-xs font-semibold ${d.days <= 15 ? "text-[#CE1126]" : "text-slate-700"}`}>{new Date(d.deadline).toLocaleDateString(locale)} · {d.days} {t("days")}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Panel>
  );
}
